<template>
	<div class='story'>
		<div class='scrolly'>
			<figure>
				<Kaart />
			</figure>

			<article class='knd-steps'>
				<div
					v-for='(step, index) in stepper' 
					:key='"step" + index'  
					class='step' 
					:data-key="step.label"
					:class="step.className"
					>
					<div class='step-inner'>
						<div>
							<div v-html="step.content"></div>
						</div>
					</div>
				</div>
			</article>
		</div>

	</div>
</template>

<script>
	import scrollama from "scrollama";

	import Kaart from '@/story/kaart/kaart';

	import './index.scss';

	let stepper = [
		{
			content: "<p>Op deze kaart zie je in het rood waar de bestaande distributiecentra gevestigd zijn. En er komen steeds meer van dit soort grote pakhuizen bij.</p>",
			label: 'huidig',
			className: 'knd-first'
		},
		{
			content: "<p>Op deze kaart zie je in het paars welke grote pakhuizen er nog gepland staan in het land. Het gaat om grote XL- en XXL-distributiecentra waarvan de bouwplannen zijn goedgekeurd en waarvoor de vergunningen zijn ingediend of afgegeven.</p><p>Een XL-distributiecentrum heeft een oppervlakte van 20 duizend vierkante meter, een XXL-distributiecentrum telt minstens 40 duizend vierkante meter.</p><p class='knd-small'>Er is één distributiecentrum van 17500 vierkante meter, deze hebben we meegenomen omdat omwonenden hier ook in verzet kwamen tegen de bouw ervan.</p>",
			label: 'cobouw',
			className: 'knd-cobouw'
		},
		{	
			content: '<p>Sommige gemeenten hebben nog grond beschikbaar voor grootschalige logistiek, waar de komende jaren ook grote pakhuizen kunnen komen te staan. Vaak liggen de bestemmingsplannen al op de plank.  Deze locaties zijn rood op de kaart.</p>',
			label: 'investico',
			className: 'knd-investico'
		},
		{	
			content: '<p>Op deze kaart zie je welke grote distributiecentra in groen gebied gepland staan, zoals in een weiland, en dus niet op een bestaand industrieterrein komen.</p>',
			label: 'groen',
			className: 'knd-groen'
		},
		{	
			content: '<p>Vul je postcode in om te zien of er een groot distributiecentrum bij jou in de buurt komt.</p>',
			label: 'postcode',
			className: 'knd-postcode'
		}

	]

export default {
	name: 'App',
	components: {Kaart},
	data: function() {
		return {
			stepper
		}
	},
	mounted: function() {
		this.stackedBarScroller = scrollama();
		this.setupScroller();
	},
	computed: {},
	watch: {},

	methods: {
		setupScroller() {
			var midpoint = Math.floor(window.innerHeight * 0.6) + "px";

			this.steps = document.querySelectorAll(".scrolly .step");
			
			this.stackedBarScroller
			.setup({
				container: ".scrolly",
				graphic: ".scrolly figure",
				text: ".scrolly article",
				step: this.steps,
				offset: midpoint,
				debug: false
			})
			.onStepEnter(this.handleStepEnter)
			.onStepExit(this.handleStepExit);

		},

		handleStepEnter(response) {
			// response = { element, direction, index }
			this.$store.dispatch('updateStep', {index: response.index, ...response.element.dataset});

			for (let i =0; i < this.steps.length; i++) {
				if(i === response.index) {
					this.steps[i].classList.add('is-active');
				} else  {
					this.steps[i].classList.remove('is-active');
				}

			}
		},

		handleStepExit(response) {
			response.element.classList.remove('is-active');
		}
	}
}
</script>